import { CobranzasAxios, COMPANY } from './config'

export const getMovements = async () => {
  const res = await CobranzasAxios.get(`/operation/${COMPANY}`)
  return res.data
}

export const postMovements = async (data) => {
  const res = await CobranzasAxios.post(`/operation/${COMPANY}`, data)
  return res.data
}

export const putMovements = async (data, id) => {
  const res = await CobranzasAxios.put(`/operation/${id}`, data)
  return res.data
}
